import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { RawAdvisorReview, AdvisorUid, Advisor } from 'components/features/coaching/advisor/types/advisor'
import { RequestAction, createRequestActionCreators, createPayloadAction } from 'helpers/actionsHelpers'
import { AdvisorMeetingWizardFields, FlowSpecificFields, AdvisorMeetingWizardNonRegularFields } from 'components/features/coaching/advisorMeeting/types/requests'
import { createAction } from 'helpers/actionHelpers/createAction'
import { MeetingUid, Meeting } from 'components/features/coaching/advisorPage/types/interfaces'
import { ReviewFormFields } from 'components/features/coaching/advisorReviewPage/AdvisorReviewPage/AdvisorReviewPage'
import { AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { PayloadAction } from 'interfaces/action'

export type AdvisorsRequestResponse = {
  advisors: AdvisorDataState['advisors'],
  advisorsPagination: AdvisorDataState['advisorsPagination'],
  timeslots: Record<AdvisorUid, string[]>,
  timeslotsPagination: AdvisorDataState['timeslotsPagination'],
}
export class AdvisorsRequestAction extends createRequestAction<
  'ADVISORS_REQUEST',
  Pick<AdvisorMeetingWizardFields, 'topics' | 'notes'> & FlowSpecificFields,
  AdvisorsRequestResponse
>('ADVISORS_REQUEST') {}

export class CancelAdvisorsRequestAction extends createAction<'CANCEL_ADVISORS_REQUEST', void>('CANCEL_ADVISORS_REQUEST') {}

export class ResetAdvisorsRequestStateAction extends createAction<'RESET_ADVISORS_REQUEST_STATE', void>('RESET_ADVISORS_REQUEST_STATE') {}

export type AdvisorsPatchReviewPayload =
  & Partial<Omit<ReviewFormFields, 'meeting_uid'>>
  & {
    meeting_uid: MeetingUid
  }
export class AdvisorsPatchReviewAction extends createRequestAction<'ADVISORS_PATCH_REVIEW', AdvisorsPatchReviewPayload, RawAdvisorReview>('ADVISORS_PATCH_REVIEW') {}

type CreateAdvisorMeetingPayload = AdvisorMeetingWizardFields | AdvisorMeetingWizardNonRegularFields
type CreateAdvisorMeetingResponse = {
  meeting: Meeting
  advisor: Advisor
}
export const CREATE_ADVISOR_MEETING = 'CREATE_ADVISOR_MEETING' as const
export type CreateAdvisorMeeting = RequestAction<typeof CREATE_ADVISOR_MEETING, CreateAdvisorMeetingPayload, CreateAdvisorMeetingResponse>
export const createAdvisorMeetingActionCreator = createRequestActionCreators<typeof CREATE_ADVISOR_MEETING, CreateAdvisorMeetingPayload, CreateAdvisorMeetingResponse>(CREATE_ADVISOR_MEETING)

export class ResetCreateMeetingAction extends createAction<'RESET_CREATE_MEETING', void>('RESET_CREATE_MEETING') {}
export class ResetCancelMeetingAction extends createAction<'RESET_CANCEL_MEETING', void>('RESET_CANCEL_MEETING') {}

type CancelAdvisorMeetingPayload = {
  uid: MeetingUid
}
type CancelAdvisorMeetingResponse = {
  meeting: Meeting
  advisor: Advisor
}
export const CANCEL_ADVISOR_MEETING = 'CANCEL_ADVISOR_MEETING' as const
export type CancelAdvisorMeeting = RequestAction<typeof CANCEL_ADVISOR_MEETING, CancelAdvisorMeetingPayload, CancelAdvisorMeetingResponse>
export const cancelAdvisorMeetingActionCreator = createRequestActionCreators<typeof CANCEL_ADVISOR_MEETING, CancelAdvisorMeetingPayload, CancelAdvisorMeetingResponse>(CANCEL_ADVISOR_MEETING)

type DeleteAdvisorMeetingPayload = {
  uid: MeetingUid
}
export const DELETE_ADVISOR_MEETING = 'DELETE_ADVISOR_MEETING' as const
type DeleteAdvisorMeeting = RequestAction<typeof DELETE_ADVISOR_MEETING, DeleteAdvisorMeetingPayload, {}>
export const deleteAdvisorMeetingActionCreator = createRequestActionCreators<typeof DELETE_ADVISOR_MEETING, DeleteAdvisorMeetingPayload, {}>(DELETE_ADVISOR_MEETING)


export const SET_VISIBLE_ADVISORS = 'SET_VISIBLE_ADVISORS' as const
type SetVisibleAdvisors = PayloadAction<typeof SET_VISIBLE_ADVISORS, number>
export const setVisibleAdvisorsActionCreator = (amount: number): SetVisibleAdvisors =>
  createPayloadAction(SET_VISIBLE_ADVISORS, amount)

type GetTimeslotsResponse = Pick<AdvisorsRequestResponse, 'timeslots' | 'timeslotsPagination'>
export class GetAdvisorTimeslotsAction extends createRequestAction<'GET_ADVISOR_TIMESLOT', { advisor_uid: AdvisorUid }, GetTimeslotsResponse>('GET_ADVISOR_TIMESLOT') {}

export class SubscribeAndCreateMeetingAction extends createRequestAction<'SUBSCRIBE_AND_CREATE_MEETING', {
  amount: number
  fields: AdvisorMeetingWizardFields
}, void>('SUBSCRIBE_AND_CREATE_MEETING') {}


export type AdvisorMeetingActions =
  | typeof AdvisorsRequestAction.Type
  | ResetAdvisorsRequestStateAction
  | CreateAdvisorMeeting
  | ResetCreateMeetingAction
  | ResetCancelMeetingAction
  | CancelAdvisorMeeting
  | DeleteAdvisorMeeting
  | typeof AdvisorsPatchReviewAction.Type
  | CancelAdvisorsRequestAction
  | SetVisibleAdvisors
  | typeof GetAdvisorTimeslotsAction.Type
  | typeof SubscribeAndCreateMeetingAction.Type
